<template>
  <div>
    <div
      class="modal fade"
      id="modalPatio"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalPatioTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalPatioTitle">Veículo no Pátio</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5">
                <img class="car-pic" :src="dataModal.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="titlePR">Dados do Veículo:</div>
                  <div class="car-desc">
                    <div class="text">
                      {{ dataModal.description }} {{ dataModal.color }}
                    </div>
                    <div class="data">{{ dataModal.board }}</div>
                    <div class="clearfix"></div>
                  </div>

                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask
                        disabled
                        class="km-in-modal"
                        :value="dataModal.current_km"
                        :mask="['####', '#.###', '##.###', '###.###']"
                      />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="buttons">
                    <a href="/myreserves/add" class="btn btn-alt float-right"
                      >Agendar Reserva</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="last-trips">
              <div class="title">Últimas viagens deste veículo:</div>
              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Condutor</th>
                      <th scope="col">Retirado em</th>
                      <th scope="col">Entregue em</th>
                      <th scope="col">Ações</th>
                    </tr>
                  </thead>
                  <tbody v-if="dataModal.last_trips.length > 0">
                    <tr
                      v-for="lastTrip in dataModal.last_trips"
                      :key="lastTrip.id"
                    >
                      <td v-if="lastTrip && lastTrip.user">
                        {{ lastTrip.user.name }}
                      </td>
                      <td v-if="lastTrip && lastTrip.checkout">
                        {{
                          lastTrip.checkout ? lastTrip.checkout.retreat_at : ""
                        }}
                      </td>
                      <td v-if="lastTrip && lastTrip.checkin">
                        {{
                          lastTrip.checkin ? lastTrip.checkin.devoluted_at : ""
                        }}
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-crud check"
                          @click="openModal(lastTrip)"
                          data-tooltip="tooltip"
                          data-dismiss="modal"
                          data-toggle="modal"
                          data-target="#modalLastTrips"
                          title="Consultar informações"
                        >
                          <i class="fas fa-sign-out-alt"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <pagination
                          style="margin-top: 25px"
                          :records="dataModal.lastTrips.total"
                          :options="options"
                          :per-page="5"
                          @paginate="paginate"
                        ></pagination>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" align="center">
                        Este veículo ainda não realizou viagens.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination } from "vue-pagination-2";
export default {
  components: { Pagination },
  props: ["modalStatus", "dataModal"],

  data() {
    return {
      km: " km",
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        page: 1,
        chunk: 4,
        chunksNavigation: "fixed",
      },
    };
  },
  watch: {
    modalStatus: function (newStatus) {
      if (newStatus == true) {
        this.startModal();
      }
    },
  },
  computed: {},
  mounted() {
    if (this.modalStatus == true) {
      this.startModal();
    }
  },
  methods: {
    paginate(page) {
      const self = this;
      self.$emit(
        "openModals",
        self.dataModal.id,
        self.dataModal.status,
        self.dataModal,
        page
      );
    },
    openModal(object) {
      this.$emit("OMDCk", object);
    },
    startModal() {
      this.clean();
      $("#modalPatio").modal("toggle");
    },
    clean() {
      this.$emit("changeModal", false);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Modals/AvailableModal.vue